import BaseModuleMixin from '@/app/shared/mixins/BaseModuleMixin';
import BaseGestaoMixin from '@/app/shared/mixins/BaseGestaoMixin';

export default {
    mixins: [
        BaseModuleMixin,
        BaseGestaoMixin,
    ],
    props: {
        moduleId: {
            type: String,
            required: true
        }
    },
    computed: {
        moduleInternalCode() {
            return this.moduleId;
        },
    },

}
